import { RadioGroupInput } from './RadioGroup'

export const YesNoRadioOptions = [
  {
    value: 'yes',
    label: 'Yes'
  },
  {
    value: 'no',
    label: 'No'
  }
]

export const QuestionRadioButton = props => {
  const { question, radioButtons, fieldName, name, yesNo, ...rest } = props
  return (
    <div className='row middle-xs nh-form-margin-bottom'>
      <div
        style={{ color: '#BBB' }}
        className='col-xs-6 col-sm-7 col-md-8'
      >
        {question}
      </div>
      <div className='col-xs-6 col-sm-5 col-md-4'>
        <RadioGroupInput
          name={name || fieldName}
          options={yesNo ? YesNoRadioOptions : radioButtons}
          {...rest}
        />
      </div>
    </div>
  )
}

export const QuestionRadioButtonInput = QuestionRadioButton
